import { useState } from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";
import CreateModal from "@/components/modals/CreateModal";

export default function Layout({ children, users, projects, currentUser, onProjectCreated }) {
  const [createModalOpen, setCreateModalOpen] = useState(false);

  return (
    <div className="flex h-screen w-full bg-white overflow-hidden" data-testid="app-layout">
      <Sidebar projects={projects} currentUser={currentUser} onProjectCreated={onProjectCreated} />
      <div className="flex-1 flex flex-col min-w-0 overflow-hidden">
        <Topbar
          currentUser={currentUser}
          onCreateIssue={() => setCreateModalOpen(true)}
        />
        <main className="flex-1 overflow-hidden">{children}</main>
      </div>
      <CreateModal
        open={createModalOpen}
        onOpenChange={setCreateModalOpen}
        projects={projects}
        users={users}
        currentUser={currentUser}
      />
    </div>
  );
}
